export const pricingKeys = {
  all: ['admin-pricing'] as const,
  list: (tenantId: string | null) => ['admin-pricing', 'list', tenantId ?? 'all'] as const,
};
